import * as yup from "yup";

import { ISubscriptionAndEmailSettings } from "../../interfaces-and-types";

export const subscriptionAndEmailValidationSchema: yup.SchemaOf<ISubscriptionAndEmailSettings> =
  yup
    .object({
      email_receipt_to_customers: yup.boolean().required(),
      email_receipt_to_me: yup.boolean().required(),
      email_receipt_to_team_members: yup.boolean().required(),
      send_emails_about_renewals: yup.boolean().required(),
      send_emails_about_expiring_cards: yup.boolean().required(),
      send_merchant_reminders_for_unpaid_subscriptions: yup
        .boolean()
        .required(),
      send_customers_reminders_for_unpaid_subscriptions: yup
        .boolean()
        .required(),
      email_invoices_to_customers: yup.boolean().required(),
      notify_customers_on_failed_payments: yup.boolean().required(),
      cancel_and_notify_customer_on_failed_retries: yup.boolean().required(),
      include_current_balance_in_emails: yup.boolean().required(),

      retry_failed_payments_after_days: yup.number().required().nullable(),
      resend_expired_invoices_after_days: yup.number().required().nullable(),
    })
    .required();
